import { defineType } from "sanity";
import { multilingualStringPreview } from "../../base/multilingualArrayString";

export default defineType({
  name: "linkCTA",
  type: "object",
  title: "Link CTA",
  fields: [
    {
      name: "label",
      type: "multilingualArrayString",
      description: 'leave empty for "Discover More"'
    },
    {
      name: "url",
      type: "multilingualUrl",
      description: "",
      validation: (Rule) => Rule.required()
    },
    {
      name: "type",
      type: "buttonType"
    },
    {
      title: "Open in new tab",
      name: "openInNewTab",
      type: "boolean"
    }
  ],
  preview: {
    select: {
      title: "label"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title) || "Discover more"
      };
    }
  }
});
